import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as mapboxgl from 'mapbox-gl';
import { BehaviorSubject, interval } from 'rxjs';
import { take } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { MapQueryParams } from './map-query-params';
import { MapService } from './map.service';

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MapComponent implements OnInit {

  mapbox: mapboxgl.Map;

  isLoaded$ = new BehaviorSubject<boolean>(false);
  isLoadedStyle$ = new BehaviorSubject<boolean>(false);
  isLoadedSourceData$ = new BehaviorSubject<boolean>(false);

  constructor(
    private mapService: MapService,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.initMap();
  }

  private loadingInformations() {

    this.mapbox.once('load', (e) => {
      this.mapService.map$.next(this.mapbox);
      this.isLoaded$.next(true);
    });

    this.mapbox.on('sourcedata', (e) => {
      this.isLoadedSourceData$.next(e.isSourceLoaded);
    });

    const timer = interval(200).subscribe(t => {
      if (this.mapbox.isStyleLoaded()) {
        timer.unsubscribe();
        this.isLoadedStyle$.next(true);
      }
    });
  }

  private initMap() {
    const accessToken = environment.mapbox.accessToken;

    this.route.queryParams.
      pipe(take(1))
      .subscribe((p: MapQueryParams) => {

        const zoom = p.zoom ? p.zoom : environment.mapbox.default.zoom;
        const lng = p.lng ? p.lng : -55.5153582746718;
        const lat = p.lat ? p.lat : -11.8567917953487;

        this.mapbox = new mapboxgl.Map({
          accessToken,
          container: 'app-map-container',
          style: environment.mapbox.styles.street,
          center: [lng, lat],
          zoom
        });

        this.loadingInformations();
      });
  }
}
